// Module
var code = "<div class=\"GetCareLandingTitle\"> <p class=\"GetCareLandingTitle__title\">Search for an in-network provider</p> <p class=\"GetCareLandingTitle__description\"> Our search tool takes the guesswork out of finding providers in your network. </p> </div> ";
// Exports
var _module_exports = code;;
var path = '@collectivehealth/frontend-member-v2/pages/getCare/getCareLandingTitle/getCareLandingTitle.html';
var angular = require('angular');
angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;